import TeamMember from "components/TeamMember"

export default function InlineTeamMembers({ blok }) {
  return blok?.team_members?.length ? (
    <section className="py-4">
      <h2 className="text-m2 mb-2 leading-9 font-primary uppercase">{blok?.title}</h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:flex lg:flex-wrap gap-8">
        {blok.team_members.map((member) => (
          <TeamMember {...member} key={member.full_slug} />
        ))}
      </div>
    </section>
  ) : null
}
